import { render, staticRenderFns } from "./IndividualResume.vue?vue&type=template&id=4ed9052a&scoped=true"
import script from "./IndividualResume.vue?vue&type=script&lang=js"
export * from "./IndividualResume.vue?vue&type=script&lang=js"
import style0 from "./IndividualResume.vue?vue&type=style&index=0&id=4ed9052a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9052a",
  null
  
)

export default component.exports